import {
    View,
    Text,
    Dimensions,
    TouchableOpacity,
    Platform,
    ScrollView,
  } from "react-native";
  import React, { useEffect, useState } from "react";
  import Modal from "react-native-modal";
  import PDFReader from "rn-pdf-reader-js";
  
  import { useDispatch, useSelector } from "react-redux";
  import { Feather } from "@expo/vector-icons";
  import MyModal from "./MyModal";
  import MyInputWithLabel from "../custom/MyInputWithLabel";
  import MyText from "../custom/MyText";
  import translate from "../../functions/translate";
  import MyButton from "../custom/MyButton";
  import StepSlide from "../animation/StepSlide";
  import { danger, orange, primary } from "../../colors";
  import CodeInput from "../custom/CodeInput";
  import { noModal } from "../../redux/modal/modalAction";
  import userActivation from "../../api/post/userActivation";
  import { addToken } from "../../redux/main/mainAction";
  import { storeStringData } from "../../functions/db/db";
  import { useNavigation } from "@react-navigation/native";
  import addSignupGift from "../../api/wallet/addSignupGift";
  import { height } from "../../imports";
  
  export default function PdfModal({
    pdfName,
    open,
    onClose,
    url,
    phone,
    setConfirmed,
    temporaryToken,
    otp,
  }) {
    const [code, setCode] = useState(null);
    const modal = useSelector((store) => store.modal);
    const dispatch = useDispatch();
    const [changed, setChanged] = useState(false);
    const navigation = useNavigation();
  
    return (
      <Modal isVisible={open} style={{ zIndex: 1000 }} onBackdropPress={onClose}>
        <ScrollView>
          <View
            style={{
              width: "100%",
              backgroundColor: "#fefefe",
              padding: 10,
              borderRadius: 10,
              minHeight: 200,
              marginTop: 20,
            }}
          >
            <View style={{ flexDirection: "row" }}>
              <TouchableOpacity onPress={onClose}>
                <Feather name="x" size={24} color={danger} />
              </TouchableOpacity>
              <MyText style={{ marginHorizontal: 10 }}>{pdfName}</MyText>
            </View>
            <View>
              <View
                style={{
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {Platform.OS !== "web" && (
                  <PDFReader
                    source={{
                      uri: url,
                    }}
                    style={{ height: height - 150, width: "100%" }}
                  />
                )}
              </View>
            </View>
          </View>
        </ScrollView>
      </Modal>
    );
  }
  